import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAumyeState } from 'src/app/state-management/states/aumye.state';
import * as fromCalendarActions from 'src/app/state-management/actions/calendar.actions';
import * as fromDashboardActions from 'src/app/state-management/actions/dashboard.action';
import { Observable, Subject, takeUntil } from 'rxjs';
import { ICalendarState } from 'src/app/state-management/states/aumye-calendar.state';
import { IDashboardState } from 'src/app/state-management/states/aumye-dashboard.state';
import { Visitor } from 'src/app/models/visitor';
import { getSummaryOfVisitDate } from 'src/app/utils/table-utils';
import { visitorSummary } from 'src/app/models/table/visitorTable';
import { MatDialog } from '@angular/material/dialog';
import { UserRegDetails } from 'src/app/models/user';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { ScreenType } from 'src/app/enums/ScreenType';

@Component({
  selector: 'app-visitor-calendar-container',
  templateUrl: './visitor-calendar-container.component.html',
  styleUrls: ['./visitor-calendar-container.component.scss'],
})
export class VisitorCalendarContainerComponent implements OnInit {
  @ViewChild('VisitorInviteDialog', { static: true })
  visitorInviteDialog: TemplateRef<any>;
  destroyed$: Subject<any> = new Subject<any>();
  calendarState$: Observable<ICalendarState>;
  calendarState: ICalendarState;
  dashboardState$: Observable<IDashboardState>;
  dashboardData: IDashboardState;
  isCalendarLoaded = false;
  selectedDate: Date;
  isDateSelected = false;
  hostLists: UserRegDetails[];
  visitorList: Visitor[];
  visitorData: Visitor;
  isShowVisitorDetail = false;
  dimension: {
    height: number;
    width: number;
  };
  dateDetails: Date;
  chartData: visitorSummary;
  screenSize: ScreenType;

  constructor(
    private store: Store<IAumyeState>,
    private dialog: MatDialog,
    private _screenSize: AumyeResponsiveScreenService
  ) {
    this.calendarState$ = this.store.select('aumyeCalendarState');
    this.dashboardState$ = this.store.select('aumyeDashboardState');
    this.calendarState$.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
      this.calendarState = data;
      this.selectedDate = data.visitorCalendarDetails.selectedDate;
    });
    this.dashboardState$.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
      this.dashboardData = data;
      this.visitorList = this.dashboardData.visitorDetails.visitorList;
      this.hostLists = data.orgUserList;
    });
    this._screenSize.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }
  ngOnInit(): void {
    this.getChartData(new Date());
  }
  getCalendarDimensions(val: any) {
    const dimension = {
      height: val.height,
      width: val.width,
    };
    this.dimension = dimension;
    this.isCalendarLoaded = true;
    this.store.dispatch(
      new fromCalendarActions.GetCalendarDimensions(this.dimension)
    );
    this.getNewSelectedDate(new Date());
  }
  getNewSelectedDate(val: Date) {
    const details = {
      todayDateFull: val,
      todayDate: val.getDate(),
      todayDay: val.getDay(),
      todayMonth: val.getMonth(),
    };
    if (!this.calendarState.status.isTimeSlotsLoaded)
      this.store.dispatch(new fromCalendarActions.GetTimeSlots(details));
  }
  onSelectedDateTimeSlot(val: Date) {
    this.store.dispatch(new fromCalendarActions.SelectedDateTimeSlot(val));
  }
  onAddNewVisitor(val: any) {
    this.store.dispatch(new fromCalendarActions.InitVisitorInvite({}));
  }
  createNewVisitorInvite(val: any) {
    const filteredVisitors: Visitor[] = this.visitorList.filter(
      (x) => x.visitorID == val.visitorId
    );
    val['visitorDetails'] = filteredVisitors;

    this.store.dispatch(new fromCalendarActions.CreateNewVisitorInvite(val));
    // this.store.dispatch(new fromCalendarActions.CheckExistingVisitor(val));

    this.openDialog();
  }
  updateExistingVisitor(val: any) {
    this.store.dispatch(new fromDashboardActions.UpdateVisitorDetails(val));
  }
  getSelectedtDateForDetails(val: Date) {
    this.dateDetails = val;
    this.getChartData(val);
  }
  getChartData(visDate: Date) {
    this.chartData = getSummaryOfVisitDate(this.visitorList, visDate);
  }
  openDialog() {
    this.dialog.open(this.visitorInviteDialog);
    const dialogRef = this.dialog.open(this.visitorInviteDialog, {
      disableClose: true,
    });
  }
  cancelVisitorInvite() {
    this.store.dispatch(new fromCalendarActions.CancelVisitorInvite({}));
  }
  onShowVisitorDetail(val: any) {
    this.visitorData = val;
    this.isShowVisitorDetail = true;
  }
  onCloseVisitorDetail() {
    this.isShowVisitorDetail = false;
  }
  ScreenType = ScreenType;
}
